import { Injectable } from '@angular/core';
import { SIDENAV_COMPONENT } from '@app/shared/types/enums';
import { Subject } from 'rxjs';

export interface ISidenav {
  isOpen: boolean;
  component: SIDENAV_COMPONENT | null;
  titleKey: any;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  // isOpen = false;
  // openSidenavId: string | null = '';
  private readonly _open = new Subject<ISidenav>();

  private readonly _statusChanged$ = new Subject<ISidenav>();
  public statusChanged$ = this._statusChanged$.asObservable();
  private monitoringCallBack: ((component: SIDENAV_COMPONENT) => void) | null = null;

  open(component: SIDENAV_COMPONENT, titleKey: string, data?: any) {
    console.log(component, titleKey, data);

    this._statusChanged$.next({ isOpen: true, component, titleKey, data });
    if (this.monitoringCallBack) {
      this.monitoringCallBack(component);
    }
  }

  close(sidenavId?: string) {
    // if (this.openSidenavId === sidenavId) {
    //   this.openSidenavId = null;
    // }
    // this.isOpen = false;
    this._statusChanged$.next({ isOpen: false, component: null, titleKey: '' });
  }
  setMonitoringCallBack(callback: (component: SIDENAV_COMPONENT) => void) {
    this.monitoringCallBack = callback;
  }

  // getIsOpenSubject() {
  //   return this.isOpenSubject.asObservable();
  // }
}
